<template>
  <v-container fluid grid-list-md>
    <v-row wrap>
      <v-col justify-center>
        <v-card>
          <v-card-text>
            <v-container fluid style="padding: 0px;">
              <v-row
                class="my-2"
                justify="center">
                <v-btn
                  :loading="isLoading && currentMode == 0 && !isEditing"
                  :outlined="currentMode != 0"
                  :disabled="isLoading"
                  rounded
                  class="ml-4"
                  color="primary"
                  @click="currentMode = 0"
                  ><v-icon left >mdi-account-arrow-down</v-icon>
                  Children
                </v-btn>
                <v-btn
                  :loading="isLoading && currentMode == 1 && !isEditing"
                  :outlined="currentMode != 1"
                  :disabled="isLoading"
                  rounded
                  color="primary"
                  class="mx-2"
                  @click="currentMode = 1"
                  ><v-icon left >mdi-account-arrow-up</v-icon>
                  Parents
                </v-btn>
                <v-spacer></v-spacer>
                <!-- Mode Toggle -->
                <v-btn
                  :loading="isLoading && isEditing"
                  :outlined="!isEditing"
                  :disabled="isLoading"
                  rounded
                  dark
                  class="mr-4"
                  color="primary"
                  @click="isEditing = !isEditing"
                  ><v-icon left>mdi-account-multiple-plus</v-icon>
                  Add {{ getModeLabel() }}
                </v-btn>
              </v-row>
              <v-divider class="ma-4"></v-divider>
              <v-row wrap>
                <v-col cols="12">
                  <v-text-field v-if="isEditing"
                    prepend-inner-icon="mdi-magnify"
                    append-icon="clear"
                    label="Search items"
                    :items="things"
                    v-model="searchText"
                    @click:append="clearSearch"
                    @input="fetchThings"
                  ></v-text-field>
                  <v-data-table
                    :search="searchText"
                    :headers="headers"
                    :items="things"
                    :loading="isLoading"
                    :item-class="() => 'tr-row-class'"
                    @click:row="editItem"
                    :options.sync="pagination"
                    item-key="id"
                    :server-items-length="totalItems"
                    :items-per-page="25"
                    :footer-props="{
                      'items-per-page-options': [10, 25, 100]
                    }">
                      <template slot="item" slot-scope="props">
                        <tr class="tr-row-class" @click="editItem(props.item)">
                          <td>{{ props.item.common.name }}</td>
                          <td>{{ props.item.common.tags.toString().replaceAll(',', ', ') }}</td>
                          <td>{{ getCategoryName(props.item) }}</td>
                          <td>
                            <v-chip
                              v-for="(label, index) in props.item.common.labels"
                              :key="index"
                              color="orange lighten-2"
                              class="ma-1"
                            >
                              {{ label }}
                            </v-chip>
                          </td>
                          <td>
                            <v-icon class="link-icon"
                              @click.stop="checkLinkedItem(props.item)"
                            > {{ checkLinkedItem(props.item, true) ? 'mdi-link-off' : 'mdi-link'}}
                            </v-icon>
                          </td>
                        </tr>
                      </template>
                    </v-data-table>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <error-snackbar v-model="errorText"></error-snackbar>
    <v-dialog v-model="showDialog" max-width="500px">
      <v-card>
        <v-card-title class="title">
          Unlink {{ getModeLabel() }}
        </v-card-title>
        <v-card-text>
          Are you sure you would like to unlink this {{ getModeLabel() }}?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="showDialog = false" text>Cancel</v-btn>
          <v-btn color="error" @click="currentMode === 0 ? unlinkChild() : unlinkParent()" text>Unlink</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import ApiRequests from '@/api/ApiRequests'
import ItemList from '@sdgsystems/vue-common/components/ItemList.vue'
import { AXIOSAPI } from '@sdgsystems/vue-common/components/requests-common'
import { mapGetters } from 'vuex'
import { LookupMixin } from '@/shared/mixins'
import ErrorSnackbar from '@sdgsystems/vue-common/components/ErrorSnackbar'

export default {
  name: 'relationship-list',

  components: {
    ErrorSnackbar,
    ItemList
  },

  mixins: [LookupMixin],

  data () {
    return {
      settings: {},
      endpoint: 'api/things/',
      errorText: '',
      currentThing: {},
      isEditing: false,
      currentMode: 0, // 0 = Children, 1 = Parents
      searchText: '',
      targetThing: {},
      // Keep track of linked children and parents for unlink/link method
      children: [],
      parents: [],
      // Item list for data table
      things: [],
      isLoading: false,
      pagination: {
        page: 1,
        itemsPerPage: 25,
        sortBy: [''],
        sortDesc: [false]
      },
      totalItems: 0,
      showDialog: false,
      headers: [
        {
          text: 'Name',
          value: 'common.name'
        },
        {
          text: 'Tags',
          value: 'common.tags'
        },
        {
          text: 'Categories',
          value: 'common.categories'
        },
        {
          text: 'Labels',
          value: 'common.labels',
          sortable: true
        },
        { text: 'Actions', value: 'actions', sortable: false }
      ]
    }
  },

  mounted () {
    this.settings = JSON.parse(JSON.stringify(this.siteSettings))
  },

  computed: {
    ...mapGetters([
      'siteSettings',
      'getCategories'
    ])
  },

  props: {
    label: String,
    value: String,
    thingID: String
  },

  created () {
    this.fetchCurrentThing()
  },

  watch: {
    currentMode: function () {
      this.isLoading = true
      this.fetchThings()
    },

    isEditing: function () {
      this.isLoading = true
      this.fetchThings()
    },

    pagination: function () {
      this.isLoading = true
      this.fetchThings()
    }
  },

  methods: {
    clearSearch: function () {
      this.searchText = ''
      this.fetchThings()
    },

    editItem: function (thing) {
      const siteParam = this.$route.query.site
      this.$router.push({name: 'itemEdit', params: {id: thing._id}, query: {site: siteParam}})
    },

    getCategoryName: function (item) {
      if (item.common.categories == null) {
        return ''
      }
      var arr = []
      for (var x in item.common.categories) {
        for (let y of this.getCategories) {
          if (y.id === item.common.categories[x]) {
            arr.push(y.name)
          }
        }
      }
      if (arr.length !== 0) {
        return arr.toString().replaceAll(',', ', ')
      } else {
        return ''
      }
    },

    getModeLabel: function () {
      if (this.currentMode === 0) {
        return 'child'
      }
      return 'parent'
    },

    checkLinkedItem: function (targetThing, isIcon) {
      if (this.currentMode === 0) { // Children Mode
        if (this.children.includes(targetThing._id)) {
          if (isIcon) {
            return true
          }
          this.targetThing = targetThing
          this.showDialog = true
          // this.unlinkChild(targetThing)
        } else {
          if (isIcon) {
            return false
          }
          this.linkChild(targetThing)
        }
      } else { // Parent Mode
        if (this.parents.includes(targetThing._id)) {
          if (isIcon) {
            return true
          }
          this.targetThing = targetThing
          this.showDialog = true
          // this.unlinkParent(targetThing)
        } else {
          if (isIcon) {
            return false
          }
          this.linkParent(targetThing)
        }
      }
    },

    linkChild: function (targetThing) {
      if (targetThing.common.parents != null) {
        if (targetThing.common.parents.find(parent => parent === this.thingID)) {
          this.errorText = 'Parent already exists'
          return
        }
        targetThing.common.parents.push(this.thingID)
      } else {
        targetThing.common.parents = [this.thingID]
      }
      AXIOSAPI.put('api/things/' + targetThing._id, targetThing)
          .then(() => {
            this.children.push(targetThing._id)
          })
          .catch(error => {
            console.log('Error: ', error)
          })
    },

    linkParent: function (targetThing) {
      if (this.currentThing.common.parents != null) {
        this.currentThing.common.parents.push(targetThing._id)
      } else {
        this.currentThing.common.parents = [targetThing._id]
      }
      AXIOSAPI.put('api/things/' + this.thingID, this.currentThing)
          .then(response => {
            this.parents.push(targetThing._id)
            // this.things = this.filterOutLinkedChildren(this.things, this.thingParents)
          })
          .catch(error => {
            console.log('Error: ', error)
          })
    },

    unlinkChild: function () {
      if (this.targetThing.common.parents != null) {
        if (this.targetThing.common.parents.find(parent => parent === this.thingID)) {
          this.isLoading = true
          this.targetThing.common.parents = this.targetThing.common.parents.filter(item => item !== this.thingID)
          AXIOSAPI.put('api/things/' + this.targetThing._id, this.targetThing)
            .then(() => {
              this.errorText = 'Child Successfully Unlinked '
              this.children = this.children.filter(item => item !== this.targetThing._id)
              if (!this.isEditing) {
                this.things = this.things.filter(item => item._id !== this.targetThing._id)
              }
              this.isLoading = false
              this.showDialog = false
              this.totalItems = this.things.length
            })
            .catch(error => {
              console.log('Error: ', error)
            })
        } else {
          this.errorText = 'Child has already been disconnected'
        }
      } else {
        this.errorText = 'Parent does not exist (Something major has gone wrong)'
      }
    },

    unlinkParent: function () {
      if (this.currentThing.common.parents != null) {
        if (this.currentThing.common.parents.find(parent => parent === this.targetThing._id)) {
          this.isLoading = true
          this.currentThing.common.parents = this.currentThing.common.parents.filter(item => item !== this.targetThing._id)
          AXIOSAPI.put('api/things/' + this.thingID, this.currentThing)
            .then(() => {
              this.errorText = 'Parent Successfully Unlinked '
              this.parents = this.parents.filter(item => item !== this.targetThing._id)
              if (!this.isEditing) {
                this.things = this.things.filter(item => item._id !== this.targetThing._id)
              }
              this.isLoading = false
              this.showDialog = false
              this.totalItems = this.things.length
            })
            .catch(error => {
              console.log('Error: ', error)
            })
        } else {
          this.errorText = 'Parent has already been disconnected'
        }
      } else {
        this.errorText = 'Parent no longer exists.'
      }
    },

    fetchCurrentThing: function () {
      ApiRequests.getThing(this.thingID)
        .then(response => {
          this.currentThing = response.data
        })
        .catch(error => {
          console.log('Error fetching current thing: ' + error)
        })
    },

    fetchThings: function () {
      if (this.currentMode === 0) { // Child Mode
        if (this.isEditing) {
          ApiRequests.thingQuery({
            search: this.searchText,
            page: this.pagination.page - 1,
            limit: this.pagination.itemsPerPage
          })
            .then(response => {
              this.things = response.data
              this.totalItems = parseInt(response.headers['x-total-count'])
              this.isLoading = false
            })
            .catch(error => {
              console.log('Error fetching things: ' + error)
            })
        } else {
          console.log('Fetching Children')
          this.fetchChildren()
        }
      } else { // Parent Mode
        if (this.isEditing) {
          ApiRequests.thingQuery({
            category: this.settings.parentCategories != null ? this.settings.parentCategories.toString() : '',
            search: this.searchText,
            page: this.pagination.page - 1,
            limit: this.pagination.itemsPerPage
          })
          .then(response => {
            this.things = response.data
            this.totalItems = parseInt(response.headers['x-total-count'])
            this.isLoading = false
          })
          .catch(error => {
            console.log('Error Fetching things: ', error)
          })
        } else {
          this.fetchThingParents()
        }
      }
    },

    fetchChildren: function () {
      ApiRequests.getChildren(this.thingID)
        .then(response => {
          this.things = response.data
          this.things.forEach((i) => this.children.push(i._id))
          this.totalItems = response.data.length
          this.isLoading = false
        })
        .catch(error => {
          console.log('Error fetching things: ' + error)
        })
    },

    fetchThingParents: function () {
      ApiRequests.getParents(this.thingID)
        .then(response => {
          this.things = response.data
          this.things.forEach((i) => this.parents.push(i._id))
          this.totalItems = response.data.length
          this.isLoading = false
        })
        .catch(error => {
          console.log('Error fetching things: ' + error)
        })
    }
  }
}
</script>
<style>
.tr-row-class {
  cursor: pointer;
}

.link-icon:hover {
  color: #1976d2;
}

.link-icon-off:hover {
  color: #ff5252;
}
</style>



// WEBPACK FOOTER //
// src/components/RelationshipList.vue